import { createEmitter } from "ts_utils";
import { SongDO } from "../data/SongDO";
import { StudentManager } from "../data/StudentManager";
import { StudentSelectionWindow, StudentSelectionWindowEvent }
	from "../data/StudentSelectionWindow";
import { AppContainer } from "../ui/AppContainer";
import { Templates } from "../ui/Templates";
import { AbstractPanelItem, SongPanelItem } from "./panel_items";
import { _LeadersSection } from "./_LeadersSection";
import { _SongSection } from "./_SongSection";
import { songMenuOverlay } from "../ui/templates/songMenuTemplates";

export class MainMenu {
	
	/**the most recent SongDO selected to be opened (from MuseScore or file)*/
	private _currentSongDO:SongDO;
	
	private _container:HTMLDivElement;
	private _overlay:HTMLDivElement;
	private _welcomeDiv:HTMLDivElement;
	private _switchUserLink:HTMLAnchorElement;
	private _songSection:_SongSection;
	private _leadersSection:_LeadersSection;
	private _initialized:boolean = false;
	
	private _resizeTimerId:number;
	
	public get event() { return this._emitter.event; }
	private _emitter = createEmitter<MainMenuEvent>();
	
	constructor(){
		
	}
	
	private async _init():Promise<void> {
		this._container = AppContainer.get().songMenuUi;
		
		this._overlay = Templates.createDiv(songMenuOverlay);
		document.querySelector('body').append(this._overlay);
		
		this._welcomeDiv = this._container.querySelector(
			"#m-currentStudent-welcome");
		this._switchUserLink = this._container.querySelector(
			"#m-switchUserLink");
		
		this._songSection = new _SongSection(this._container);
		
		this._leadersSection = new _LeadersSection(this._container);
		
		this._showStudentSelectionWindow(null);
		
		this._initialized = true;
	}
	
	public async activate():Promise<void> {
		if (!this._initialized) { await this._init(); }
		else { document.querySelector('body').append(this._overlay); }
		
		await this._updateDisplay();
		this._addListeners();
		
		this._overlay.remove();
	}
	
	public deactivate():void {
		this._removeListeners();
	}
	
	private _handleSongItemClick = (panelItem:AbstractPanelItem):void => {
		if (panelItem instanceof SongPanelItem){
			this._requestSongLoad(panelItem.songDO);
		}
	}
	
	private _requestSongLoad(songDO:SongDO):void {
		//load the song
		console.log(songDO.title);
		this._currentSongDO = songDO;
		//dispatch ready event
		let ev = new MainMenuEvent(MainMenuEventType.loadSongRequest);
		ev.songDO = songDO;
		this._emitter.emit(ev);
	}
	
	private _showStudentSelectionWindow = (e:MouseEvent):void => {
		let ssWindow = new StudentSelectionWindow();
		ssWindow.event.on(async (e:StudentSelectionWindowEvent) => {
			ssWindow.event.offAll();
			let name = StudentManager.currentStudent.name;
			this._welcomeDiv.innerHTML = `Welcome, ${name}!`;
			this._songSection.updateAssessmentScores();
			await this._leadersSection.update();
		});
	}
	
	private _onWindowResize = (e:Event):void => {
		if (this._resizeTimerId != null){
			window.clearTimeout(this._resizeTimerId);
			this._resizeTimerId = null;
		}
		
		this._resizeTimerId = window.setTimeout(this._updateDisplay, 500);
	}
	
	private _updateDisplay = async ():Promise<void> => {
		this._songSection.updateAssessmentScores();
		await this._leadersSection.update();
	}
	
	private _addListeners():void {
		AbstractPanelItem.click.on(this._handleSongItemClick);
			
		window.addEventListener("resize", this._onWindowResize);
		this._switchUserLink.addEventListener("click",
			this._showStudentSelectionWindow);
	}
	
	private _removeListeners():void {
		AbstractPanelItem.click.offAll();
		//for some reason this is not working consistently.
		// AbstractPanelItem.click.off(this._handleSongItemClick);
			
		window.removeEventListener("resize", this._onWindowResize);
		this._switchUserLink.removeEventListener("click",
			this._showStudentSelectionWindow);
	}
	
	/**the most recent SongDO selected to be opened (from MuseScore or file)*/
	public get currentSongDO():SongDO { return this._currentSongDO; }
	
	/**true if the [MainMenu] is currently displayed*/
	public get isActive():boolean { return this._container.parentNode != null; }
}

export class MainMenuEvent {
	public type:MainMenuEventType;
	public songDO:SongDO;
	
	constructor(type:MainMenuEventType){
		this.type = type;
	}
}

export enum MainMenuEventType {
	loadSongRequest
}